import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormHexagon: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconFormHexagon"><Path d="M10.623 2.17779C11.4738 1.68667 12.5223 1.68667 13.373 2.17779L19.8164 5.8985C20.6671 6.38963 21.1912 7.29712 21.1914 8.27936V15.7208C21.1913 16.703 20.6671 17.6104 19.8164 18.1016L13.373 21.8223C12.5222 22.3135 11.4739 22.3135 10.623 21.8223L4.17969 18.1016C3.32901 17.6104 2.80483 16.703 2.80469 15.7208V8.27936C2.80492 7.29712 3.32902 6.38963 4.17969 5.8985L10.623 2.17779Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFormHexagon;
